import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useUpdateTaskMutation } from '../../features/tasks/tasksApi';

const UpdateForm = ({ teams, projects, defaultData }) => {
    const [updateTask, { isLoading, isError, isSuccess, error }] = useUpdateTaskMutation()
    const navigate = useNavigate();
    const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm();

    const onSubmit = data => {
        const teamMember = teams.find(single => single.id === parseInt(data.teamMember))
        const project = projects.find(single => single.id === parseInt(data.projectName))
        const mainData = {
            taskName: data.taskName,
            deadline: data.deadline,
            teamMember,
            project,
            id: defaultData.id
        }
        console.log(mainData)
        updateTask(mainData)
    };

    useEffect(() => {
        if (isSuccess) {
            navigate('/')
        }
    }, [isSuccess, isError])

    useEffect(() => {
        if (defaultData?.id) {

            Object.keys(defaultData).forEach(key => {
                if (key === 'id') {
                    return
                }

                if (key === 'project') {
                    setValue('projectName', defaultData[key].id)
                } else if (key === 'teamMember') {
                    setValue(key, defaultData[key].id)
                }
                else {
                    setValue(key, defaultData[key])
                }
            })
        }
    }, [defaultData, setValue, isError])

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            {isError && <div>
                Something is wrong try again
            </div>}
            <div className="fieldContainer">
                <label for="lws-taskName">Task Name</label>
                <input
                    type="text"
                    name="taskName"
                    id="lws-taskName"
                    {...register("taskName", { required: true })}
                    required
                    placeholder="Implement RTK Query"
                />
            </div>

            <div className="fieldContainer">
                <label>Assign To</label>
                <select   {...register("teamMember", { required: true })} name="teamMember" id="lws-teamMember" required>
                    <option value="" hidden defaultChecked>Select Job</option>
                    {
                        teams?.map(single => <option key={single.id} value={single.id}>{single.name}</option>)
                    }
                </select>
            </div>
            <div className="fieldContainer">
                <label for="lws-projectName">Project Name</label>
                <select id="lws-projectName"   {...register("projectName", { required: true })} name="projectName" required>
                    <option value="" hidden defaultChecked>Select Project</option>
                    {
                        projects?.map(single => <option key={single.id} value={single.id}>{single.projectName}</option>)
                    }
                </select>
            </div>

            <div className="fieldContainer">
                <label for="lws-deadline"   >Deadline</label>
                <input type="date" name="deadline" {...register("deadline", { required: true })} id="lws-deadline" required />
            </div>

            <div className="text-right">
                <button disabled={isLoading} type="submit" className="lws-submit">Save</button>
            </div>

        </form>
    );
};

export default UpdateForm;